import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/connectory-gitlab/connectory-web/node_modules/.pnpm/sonner@2.0.7_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/connectory-gitlab/connectory-web/src/app/globals.css");
